import { ItemdetailsComponent } from './../itemdetails/itemdetails.component';
import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class ItemdetailsCandeactiveGuardService implements CanDeactivate<ItemdetailsComponent>{

  canDeactivate(component: ItemdetailsComponent): boolean {
    if (component.saveButt) {
      const lastFalseValue = sessionStorage.getItem('lastClickItemDGuward');
      if ((lastFalseValue !== undefined) && (Date.now() - parseInt(lastFalseValue, 10) < 100)) {
        sessionStorage.setItem('lastClickItemDGuward', Date.now().toString());
        return false;
      }
      const confirmation = confirm($localize`:@@itemdetailscandeactive.unsaved:Wykryto niezapisane zmiany. Czy na pewno chcesz je odrzucić ?`);
      if (confirmation === false) {
        sessionStorage.setItem('lastClickItemDGuward', Date.now().toString());
      }
      return confirmation;
    }
    return true;
  }
  constructor() { }
}
